import { OperationType } from "@cervval.js/common-action/src/action.model";
import { StringFieldConstraints } from "@cervval.js/common-sql-core";
import { anyObject } from "@cervval.js/common/src/tools/any.tools";
import { ColorHex } from "@cervval.js/common/src/tools/color.tools";
import { UnixTimestamp } from "@cervval.js/common/src/tools/timestamps.tools";

// ***** STRING *****

/**
 * UID: Max length 50 chars
 */
export type UID = string;

/**
 * Long string, max. 8192 characters
 */
export type LONG_STRING = string;

/**
 * Unlimited text
 */
export type TEXT = string;

/**
 * Tinymce, no length restrictions (use TEXT for column in db)
 */
export type TINYMCE = string;

/**
 * Description: Max length 255 chars
 */
export type DESCRIPTION = string;

/**
 * Normal string, length: Max length 256
 */
export type STRING = string;

/**
 * An array of string
 */
export type STRING_ARRAY = string[];

/**
 * Short_string: Max length 64 chars
 */
export type SHORT_STRING = string;

/**
 * Email string, length: Max length 255
 */
export type EMAIL = string;

/**
 * Color: Hexadecimal color (9 chars) #rrggbbaa
 */
export type COLOR = ColorHex;

/**
 * Default string value for DTO objects
 */
export const DEFAULT_DTO_STRING_VALUE = "";

// ***** NUMBER *****

/**
 * ID : Unsigned BIGINT
 */
export type ID = number;

/** 
 * ID Array (usually for association properties)
 */
export type ID_ARRAY = ID[];

/**
 * Classic number type
 */
export type NUMBER = number;


/**
 * Integer number type
 */
export type INTEGER = number;


/**
 * Float number type
 */
export type FLOAT = number;

// TIME

/**
 * Time in seconds from midnight
 */
export type TIME_IN_SECONDS = number;

/**
 * Time in minutes from midnight
 */
export type TIME_IN_MINUTES = number;

/**
 * Duration in seconds
 */
export type DURATION_IN_SECONDS = number;

/**
 * Duration in minutes
 */
export type DURATION_IN_MINUTES = number;

/**
 * Duration in days
 */
export type DURATION_IN_DAYS = number;

/**
 * Boolean
 */
export type BOOLEAN = boolean;

/**
 * BIGINT
 */
export type BIGINT = number;

export type OBJECT<T = anyObject> = anyObject & T;

export type OPERATION_TYPE = OperationType;

// ***** Constraints and FieldTypes *****

export type FieldTypes = {
    "UID": UID,
    "LONG_STRING": STRING,
    "TEXT": TEXT,
    "STRING": STRING,
    "SHORT_STRING": SHORT_STRING,
    "TINYMCE": TINYMCE,
    "DESCRIPTION": DESCRIPTION,
    "EMAIL": EMAIL,
    "COLOR": COLOR,
    "ID": ID,
    "ID_ARRAY": ID_ARRAY,
    "NUMBER": NUMBER,
    "INTEGER": INTEGER,
    "FLOAT": FLOAT,
    "TIME_IN_SECONDS": TIME_IN_SECONDS,
    "TIME_IN_MINUTES": TIME_IN_MINUTES,
    "DURATION_IN_DAYS": DURATION_IN_DAYS,
    "DURATION_IN_SECONDS": DURATION_IN_SECONDS,
    "DURATION_IN_MINUTES": DURATION_IN_MINUTES,
    "UnixTimestamp": UnixTimestamp,
    "BOOLEAN": BOOLEAN,
    "BIGINT": BIGINT,
    "OBJECT": OBJECT,
    "true": true,
    "never": never,
    "OPERATION_TYPE": OPERATION_TYPE,
    "STRING_ARRAY": STRING_ARRAY
}

// FieldTypeNames are used in SQL table definitions in order to define which marshallers should be used to marshal / unmarshal object from / to DB
export type FieldTypeName = keyof FieldTypes;

export const fieldTypeConstraints = new Map<FieldTypeName, StringFieldConstraints>();
fieldTypeConstraints.set("SHORT_STRING", { maxLength: 64 });
fieldTypeConstraints.set("STRING", { maxLength: 256 });
fieldTypeConstraints.set("LONG_STRING", { maxLength: 8192 });
fieldTypeConstraints.set("DESCRIPTION", { maxLength: 255 });
fieldTypeConstraints.set("EMAIL", { maxLength: 255 });
fieldTypeConstraints.set("COLOR", { maxLength: 50 });
fieldTypeConstraints.set("UID", { maxLength: 50 });
